import RichText from 'Custom/RichText';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/questions.module.scss';

const FAQ_USERS_1_LIST = [
  'Pain in your lower leg that does not go away',
  'Severe chest pain or heaviness in your chest',
  'Sudden shortness of breath, sharp chest pain, or coughing blood',
  'Symptoms of a severe allergic reaction, such as swollen face, tongue, or throat, trouble breathing or swallowing',
  'Sudden severe headache unlike your usual headaches',
  'Weakness or numbness in your arm, leg, or trouble speaking',
  'Sudden partial or complete blindness',
  'Yellowing of your skin or whites of your eyes, especially with fever, tiredness, loss of appetite, dark-colored urine, or light-colored bowel movements',
  'Severe pain, swelling, or tenderness in the lower stomach (abdomen)',
  'Lump in your breast',
  'Problems sleeping, lack of energy, tiredness, or you feel very sad',
  'Heavy menstrual bleeding',
  'Feeling that the implant may have broken or bent while in your arm',
];

export const FAQ_USERS_2_LIST = [
  'Aprepitant',
  'Barbiturates',
  'Bosentan',
  'Carbamazepine',
  'Felbamate',
  'Griseofulvin',
  'Oxcarbazepine',
  'Phenytoin',
  'Rifampin',
  'St. John’s wort',
  'Topiramate',
  'HIV medicines',
  'Hepatitis C virus medicines',
];

const FAQ_USERS_3_LIST_1 = [
  'Are pregnant or think you may be pregnant',
  'Have or have had blood clots, such as blood clots in your legs (deep vein thrombosis), lungs (pulmonary embolism), eyes (total or partial blindness), heart (heart attack), or brain (stroke)',
  'Have liver disease or a liver tumor',
  'Have unexplained vaginal bleeding',
  'Have breast cancer or any other cancer that is sensitive to progestin (a female hormone), now or in the past',
  'Are allergic to anything in NEXPLANON',
];

const FAQ_USERS_3_LIST_2 = [
  'Diabetes',
  'High cholesterol or triglycerides',
  'Headaches',
  'Gallbladder or kidney problems',
  'A history of depressed mood',
  'High blood pressure',
  'An allergy to numbing medicines (anesthetics) or medicines used to clean your skin (antiseptics). These medicines will be used when the implant is placed into or removed from your arm.',
];

const FAQ_EXPLORING_QUESTION_1 = {
  title: 'Is NEXPLANON a long-acting birth control?',
  linkLabel: 'birth control implant',
  link: '/what-is-nexplanon/',
  initialContent:
    ' Yes, NEXPLANON is a small (about the size of a matchstick), thin, and flexible ',
  complementaryContent: (
    <>
      &nbsp;that provides 5 years<sup>†</sup> of continuous pregnancy
      prevention. It's placed discreetly just under the skin on the inner side
      of your non-dominant upper arm by a trained healthcare professional.
    </>
  ),
  caption: (
    <>
      <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_1_HOME = {
  title: FAQ_EXPLORING_QUESTION_1.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-1-paragraph">
        {FAQ_EXPLORING_QUESTION_1.initialContent}
        <Link
          data-qa-tag="faq-exploring-question-1-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_1.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="01"
          href={FAQ_EXPLORING_QUESTION_1.link}
        >
          {FAQ_EXPLORING_QUESTION_1.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_1.complementaryContent}
      </p>
      <p data-qa-tag="faq-exploring-question-1-caption" className="caption">
        {FAQ_EXPLORING_QUESTION_1.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_1_FAQ = {
  title: FAQ_EXPLORING_QUESTION_1.title,
  content: (
    <RichText className={styles.initialContentColor}>
      <p data-qa-tag="faq-question-1-paragraph">
        {FAQ_EXPLORING_QUESTION_1.initialContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_1.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="01"
          data-qa-tag="faq-question-1-link"
          href={FAQ_EXPLORING_QUESTION_1.link}
        >
          {FAQ_EXPLORING_QUESTION_1.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_1.complementaryContent}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-1-caption">
        {FAQ_EXPLORING_QUESTION_1.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_2 = {
  title: 'Is NEXPLANON an IUD?',
  linkLabel: 'long-acting birth control option',
  link: '/birth-control-options/',
  initialContent:
    "No, it's not an intrauterine device (IUD). It is an implant that is placed in your arm. Like an IUD, it's a",
  complementaryContent: (
    <>
      . NEXPLANON lasts for 5 years.<sup>†</sup>
    </>
  ),
  caption: (
    <>
      <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_2_HOME = {
  title: FAQ_EXPLORING_QUESTION_2.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-2-paragraph">
        {FAQ_EXPLORING_QUESTION_2.initialContent}{' '}
        <Link
          data-qa-tag="faq-exploring-question-2-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_2.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="02"
          href={FAQ_EXPLORING_QUESTION_2.link}
        >
          {FAQ_EXPLORING_QUESTION_2.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_2.complementaryContent}
      </p>
      <p data-qa-tag="faq-exploring-question-2-caption" className="caption">
        {FAQ_EXPLORING_QUESTION_2.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_2_FAQ = {
  title: FAQ_EXPLORING_QUESTION_2.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-2-paragraph">
        {FAQ_EXPLORING_QUESTION_2.initialContent}{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_2.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-2-link"
          data-design-element_no="02"
          href={FAQ_EXPLORING_QUESTION_2.link}
        >
          {FAQ_EXPLORING_QUESTION_2.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_2.complementaryContent}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-2-caption">
        {FAQ_EXPLORING_QUESTION_2.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_3 = {
  title: 'How big is NEXPLANON?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-3-paragraph">
        NEXPLANON is 1.6 inches (4 cm) in length, about the size of a
        matchstick.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_4 = {
  title: 'How does NEXPLANON work?',
  linkLabel: 'NEXPLANON prevents pregnancy',
  link: '/how-does-nexplanon-work/',
  firstParagraph: (
    <>
      NEXPLANON is a hormone-releasing birth control implant for use by women to
      prevent pregnancy for up to 5 years.<sup>†</sup>
    </>
  ),
  thirdParagraph: 'NEXPLANON also changes the lining of your uterus.',
  complementaryContent:
    ' in several ways. The most important way is by stopping the release of an egg from your ovary. NEXPLANON also thickens the mucus in your cervix, and this change may keep sperm from reaching the egg.',
  caption: (
    <>
      <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_4_HOME = {
  title: FAQ_EXPLORING_QUESTION_4.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-4-paragraph">
        {FAQ_EXPLORING_QUESTION_4.firstParagraph}
      </p>
      <p>
        <Link
          data-qa-tag="faq-exploring-question-4-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_4.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="04"
          href={FAQ_EXPLORING_QUESTION_4.link}
        >
          {FAQ_EXPLORING_QUESTION_4.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_4.complementaryContent}
      </p>
      <p data-qa-tag="faq-exploring-question-4-third-paragraph">
        {FAQ_EXPLORING_QUESTION_4.thirdParagraph}
      </p>
      <p data-qa-tag="faq-exploring-question-4-caption" className="caption">
        {FAQ_EXPLORING_QUESTION_4.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_4_FAQ = {
  title: FAQ_EXPLORING_QUESTION_4.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-4-paragraph">
        {FAQ_EXPLORING_QUESTION_4.firstParagraph}
      </p>
      <p>
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_4.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-4-link"
          data-design-element_no="04"
          href={FAQ_EXPLORING_QUESTION_4.link}
        >
          {FAQ_EXPLORING_QUESTION_4.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_4.complementaryContent}
      </p>
      <p data-qa-tag="faq-exploring-question-4-third-paragraph">
        {FAQ_EXPLORING_QUESTION_4.thirdParagraph}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-4-caption">
        {FAQ_EXPLORING_QUESTION_4.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_5 = {
  title: 'Does NEXPLANON contain estrogen?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-5-paragraph">
        No. NEXPLANON does not contain estrogen.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_6 = {
  title: 'Does NEXPLANON work as well as the pill?',
  content: `NEXPLANON is over 99% effective (less than 1 pregnancy per 100 women who used NEXPLANON for 1 year) at preventing pregnancy. NEXPLANON is one of the`,
  linkLabel: 'most effective forms of birth control available',
  link: '/effectiveness/',
};

const FAQ_EXPLORING_QUESTION_6_FAQ = {
  title: FAQ_EXPLORING_QUESTION_6.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-6-paragraph">
        {`${FAQ_EXPLORING_QUESTION_6.content} `}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_6.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-6-link"
          data-design-element_no="06"
          href={FAQ_EXPLORING_QUESTION_6.link}
        >
          {FAQ_EXPLORING_QUESTION_6.linkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_6_HOME = {
  title: FAQ_EXPLORING_QUESTION_6.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-6-paragraph">
        {`${FAQ_EXPLORING_QUESTION_6.content} `}
        <Link
          data-qa-tag="faq-exploring-question-6-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_6.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="05"
          href={FAQ_EXPLORING_QUESTION_6.link}
        >
          {FAQ_EXPLORING_QUESTION_6.linkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_7 = {
  title: 'What if I want NEXPLANON for more than 5 years?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-7-paragraph">
        The NEXPLANON{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="implant must be removed"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-7-link"
          data-design-element_no="07"
          href="/removal/"
        >
          implant must be removed
        </Link>{' '}
        by the end of the fifth year. A trained healthcare professional can
        insert a new implant under your skin after removing the old one if you
        choose to continue using NEXPLANON for birth control.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_8 = {
  title:
    'What if I change my mind and want to stop using NEXPLANON before 5 years?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-8-paragraph">
        A trained healthcare professional can remove the implant at any time
        within the 5-year period. You may become pregnant as early as the first
        week after removal of the implant. If you do not want to get pregnant
        after removal of the NEXPLANON implant, you should start another birth
        control method, such as condoms, immediately.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_9 = {
  title: 'Does NEXPLANON affect my period?',
  firstLinkLabel: 'menstrual bleeding pattern',
  firstLink:
    'https://organonpro.com/en-us/product/nexplanon/bleeding-patterns/',
  secondLinkLabel: 'spotting in between periods',
  secondLink: '/period-changes/',
  initialContent:
    'The most common side effect of NEXPLANON is a change in your normal ',
  complementaryContent:
    '. In studies, 1 in 10 women stopped using the implant because of an unfavorable change in their bleeding pattern. Your period may be longer or shorter, or you may have no bleeding at all. The time between periods may vary, and you may also have ',
};

const FAQ_EXPLORING_QUESTION_9_FAQ = {
  title: FAQ_EXPLORING_QUESTION_9.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-9-paragraph">
        {FAQ_EXPLORING_QUESTION_9.initialContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-9-link"
          data-design-element_no="09"
          href={FAQ_EXPLORING_QUESTION_9.firstLink}
          target="_blank"
          rel="noopener"
        >
          {FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_9.complementaryContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="09"
          data-qa-tag="faq-question-9-link-2"
          href={FAQ_EXPLORING_QUESTION_9.secondLink}
        >
          {FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_9_PERIOD_CHANGES = {
  title: FAQ_EXPLORING_QUESTION_9.title,
  content: (
    <RichText>
      <p>
        {FAQ_EXPLORING_QUESTION_9.initialContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="Common questions"
          data-design-module_no="04"
          data-design-element_no="02"
          href={FAQ_EXPLORING_QUESTION_9.firstLink}
          target="_blank"
          rel="noopener"
        >
          {FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_9.complementaryContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="Common questions"
          data-design-module_no="04"
          data-design-element_no="02"
          href={FAQ_EXPLORING_QUESTION_9.secondLink}
        >
          {FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_10 = {
  title: 'When should I have NEXPLANON inserted in my arm?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-10-paragraph">
        Your healthcare professional will help you determine when to have{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="NEXPLANON inserted"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="10"
          data-qa-tag="faq-question-10-link"
          href="/insertion/"
        >
          NEXPLANON inserted
        </Link>
        . The timing will depend on whether you are currently using birth
        control and which method you are using. You should not use NEXPLANON if
        you are pregnant or think you may be pregnant.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_11 = {
  title: 'How do I get NEXPLANON removed?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-11-paragraph">
        NEXPLANON can be removed at any time by a trained healthcare
        professional in a minor surgical procedure during the 5-year period, but
        must be removed by the end of the fifth year. For more information about
        how to get NEXPLANON removed,{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="click here"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="11"
          data-qa-tag="faq-question-11-link"
          href="/removal/"
        >
          click here
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_12 = {
  title: 'Can I use NEXPLANON if I have a BMI over 29?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-12-paragraph">
        NEXPLANON is a birth control for women of varying body weights. In
        clinical trials of up to 3 years women over 130% of their ideal body
        weight were excluded. In a clinical trial from year 4 to 5,
        participants' BMI ranged from 17.2-64.3 kg/m<sup>2</sup>.
      </p>
    </RichText>
  ),
};

export const FAQ_EXPLORING_QUESTIONS = [
  FAQ_EXPLORING_QUESTION_1_FAQ,
  FAQ_EXPLORING_QUESTION_2_FAQ,
  FAQ_EXPLORING_QUESTION_3,
  FAQ_EXPLORING_QUESTION_4_FAQ,
  FAQ_EXPLORING_QUESTION_5,
  FAQ_EXPLORING_QUESTION_6_FAQ,
  FAQ_EXPLORING_QUESTION_7,
  FAQ_EXPLORING_QUESTION_8,
  FAQ_EXPLORING_QUESTION_9_FAQ,
  FAQ_EXPLORING_QUESTION_10,
  FAQ_EXPLORING_QUESTION_11,
  FAQ_EXPLORING_QUESTION_12,
];

export const FAQ_HOME_QUESTIONS = [
  FAQ_EXPLORING_QUESTION_1_HOME,
  FAQ_EXPLORING_QUESTION_2_HOME,
  FAQ_EXPLORING_QUESTION_3,
  FAQ_EXPLORING_QUESTION_4_HOME,
  FAQ_EXPLORING_QUESTION_6_HOME,
  FAQ_EXPLORING_QUESTION_8,
];

const FAQ_USERS_QUESTION_1 = {
  title: 'When should I call my healthcare professional?',
  firstLinkLabel: 'Call your healthcare professional',
  firstLink: '/calling-your-doctor/',
  complementaryContent: ' right away if you have: ',
};

const FAQ_NEXPLANON_USERS_QUESTION_1 = {
  title: FAQ_USERS_QUESTION_1.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-nexplanon-question-1-paragraph">
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_USERS_QUESTION_1.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="using NEXPLANON"
          data-design-module_no="03"
          data-design-element_no="01"
          data-qa-tag="faq-nexplanon-question-1-link"
          href={FAQ_USERS_QUESTION_1.firstLink}
        >
          {FAQ_USERS_QUESTION_1.firstLinkLabel}
        </Link>
        <span
          className={styles.complementaryContentColor}
          data-qa-tag="faq-nexplanon-question-1-complementary-content"
        >
          {FAQ_USERS_QUESTION_1.complementaryContent}
        </span>
      </p>
      {FAQ_USERS_1_LIST && (
        <ul className="tightened" data-qa-tag="faq-nexplanon-question-1-list">
          {FAQ_USERS_1_LIST.map((item, i) => (
            <li
              className="mt-2"
              key={`faq-users-${i}`}
              data-qa-tag={`faq-nexplanon-users-${i}-list`}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </RichText>
  ),
};

export const FAQ_NEXPLANON_USERS = [
  FAQ_NEXPLANON_USERS_QUESTION_1,
  {
    title: 'What medicines can interact with NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph">
          Tell your healthcare professional about all the medicines you take,
          including{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="prescription and non-prescription medicines"
            data-design-nori_id="Accordion"
            data-design-module_name="using NEXPLANON"
            data-design-module_no="03"
            data-design-element_no="02"
            data-qa-tag="faq-nexplanon-question-2-link"
            href="/medicine-interactions/"
          >
            prescription and non-prescription medicines
          </Link>
          , vitamins, and herbal supplements. Certain medicines may make
          NEXPLANON less effective, including:
        </p>
        {FAQ_USERS_2_LIST && (
          <ul className="tightened" data-qa-tag="faq-nexplanon-question-2-list">
            {FAQ_USERS_2_LIST.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-2-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-2">
          Ask your healthcare professional if you’re not sure if your medicine
          is listed above.
        </p>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-3">
          If you are taking medicines or herbal products that might make
          NEXPLANON less effective, you and your doctor may decide to leave
          NEXPLANON in place; in that case, an additional, non-hormonal
          contraceptive should be used. Because the effect of another medicine
          on NEXPLANON may last up to 28 days after stopping the medicine, it is
          necessary to use the additional, non-hormonal contraceptive for that
          long.
        </p>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-4">
          When you’re using NEXPLANON, tell all healthcare professionals that
          you have NEXPLANON in place in your arm.
        </p>
      </RichText>
    ),
  },
  {
    title: 'Who should not use NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-3-paragraph">
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="Do not use NEXPLANON"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="03"
            data-qa-tag="faq-nexplanon-question-3-link"
            href="/side-effects/"
          >
            Do not use NEXPLANON
          </Link>{' '}
          if you:
        </p>
        {FAQ_USERS_3_LIST_1 && (
          <ul className="tightened" data-qa-tag="faq-nexplanon-question-3-list">
            {FAQ_USERS_3_LIST_1.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-3-1-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
        <p data-qa-tag="faq-nexplanon-question-3-paragraph-2">
          Tell your healthcare professional if you have or have had any of the
          conditions listed above. Your healthcare professional can suggest a
          different method of birth control.
        </p>
        <p data-qa-tag="faq-nexplanon-question-3-paragraph-3">
          In addition, talk to your healthcare professional about using
          NEXPLANON if you have:
        </p>
        {FAQ_USERS_3_LIST_2 && (
          <ul
            className="tightened"
            data-qa-tag="faq-nexplanon-question-3-list-2"
          >
            {FAQ_USERS_3_LIST_2.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-3-1-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list-2`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
      </RichText>
    ),
  },
  {
    title: 'What if I become pregnant while using NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-4-paragraph">
          You should see a healthcare professional right away if you think that
          you might be pregnant. It’s important to remove NEXPLANON and make
          sure that the pregnancy is not ectopic (occurring outside the womb).
          Based on experience with other hormonal contraceptives, NEXPLANON is
          not likely to cause birth defects.
        </p>
      </RichText>
    ),
  },
  {
    title: 'Can I use NEXPLANON when I am breastfeeding?',
    id: 'breastfeeding',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-5-paragraph">
          If you’re breastfeeding your child, you may use NEXPLANON if 4 weeks
          have passed since you had your baby. A small amount of the hormone
          contained in NEXPLANON passes into your breast milk. The health of
          breastfed children whose mothers were using the implant has been
          studied up to 3 years of age in a small number of children. No effects
          on the growth and development of the children were seen. If you’re
          breastfeeding and want to use NEXPLANON, talk with a healthcare
          professional for more information.
        </p>
      </RichText>
    ),
  },
  {
    title: 'Will NEXPLANON be covered by insurance?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-6-paragraph">
          You may be able to get NEXPLANON for free under the Affordable Care
          Act. Check with your insurance plan for{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="cost"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="06"
            data-qa-tag="faq-nexplanon-question-6-link"
            href="/cost/"
          >
            cost
          </Link>{' '}
          and{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="insurance information"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="06"
            data-qa-tag="faq-nexplanon-question-6-link-2"
            href="/insurance-coverage/"
          >
            insurance information
          </Link>
          . You may need to pay a co-pay, deductible, or other charges.
        </p>
      </RichText>
    ),
  },
];

const FAQ_NEXPLANON_USERS_QUESTION_1_PERIOD_CHANGES = {
  title: FAQ_USERS_QUESTION_1.title,
  content: (
    <RichText>
      <p>
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_USERS_QUESTION_1.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="Common questions"
          data-design-module_no="04"
          data-design-element_no="03"
          href={FAQ_USERS_QUESTION_1.firstLink}
        >
          {FAQ_USERS_QUESTION_1.firstLinkLabel}
        </Link>
        {FAQ_USERS_QUESTION_1.complementaryContent}
      </p>
      {FAQ_USERS_1_LIST && (
        <ul className="tightened">
          {FAQ_USERS_1_LIST.map((item, i) => (
            <li key={`faq-users-${i}`}>{item}</li>
          ))}
        </ul>
      )}
    </RichText>
  ),
};

const FAQ_PERIOD_CHANGES_QUESTION_1 = {
  title:
    'How will my period affect my ability to have NEXPLANON inserted by a healthcare professional?',
  content: (
    <RichText>
      <p>
        You should have NEXPLANON inserted within 5 days of your regular
        menstrual bleeding. If NEXPLANON is inserted after the fifth day of your
        period, then you should use additional contraceptive methods, such as a
        condom, for the first 7 days after insertion.
      </p>
    </RichText>
  ),
};

const FAQ_PERIOD_CHANGES_QUESTION_2 = {
  title: 'What is considered heavy and prolonged menstrual bleeding?',
  content: (
    <RichText>
      <p>
        Heavy and prolonged bleeding means bleeding that lasts longer than usual
        or is heavier than what’s normal for you. Everyone’s cycle is a little
        different, so what’s “heavy” for one person may not be for another. The
        key is noticing a change that feels excessive or disruptive to your
        daily life.
      </p>
      <p>
        Tell your doctor immediately if you think your menstrual bleeding is
        heavy and prolonged.
      </p>
    </RichText>
  ),
};

const FAQ_PERIOD_CHANGES_QUESTION_3 = {
  title: 'When will my period return to normal after NEXPLANON is removed?',
  content: (
    <RichText>
      <p>
        After NEXPLANON is removed, your period may return to normal within a
        few weeks. However, some patients’ menstrual cycles may be irregular
        initially. You might experience spotting, heavier or lighter bleeding,
        or skipped periods. These variations are normal as your body adjusts.
        Most individuals see their menstrual cycles return to their pre-implant
        patterns within a few months.
      </p>
      <p>
        Tell your doctor immediately if you think your menstrual bleeding is
        heavy and prolonged.
      </p>
    </RichText>
  ),
};

export const PERIOD_CHANGES_QUESTIONS = [
  FAQ_PERIOD_CHANGES_QUESTION_1,
  FAQ_EXPLORING_QUESTION_9_PERIOD_CHANGES,
  FAQ_NEXPLANON_USERS_QUESTION_1_PERIOD_CHANGES,
  FAQ_PERIOD_CHANGES_QUESTION_2,
  FAQ_PERIOD_CHANGES_QUESTION_3,
];
